import Vue from "vue";
import App from "./App";
import store from "./store";
import { router } from "./router";
import dt from "@/utils/dt";
import { reqbase } from "@/utils/request";
import ULOG from "@/utils/ulog";
import { judgePrivacy } from "@/utils/utils/judgePrivacy";

import vant, { Toast } from "vant";
import "vant/lib/index.less";
import VConsole from "vconsole";

import { Plugin } from "vue-fragment";
Vue.use(Plugin);

Vue.use(vant);

dt();
ULOG.init();

Vue.prototype.$zuwuRequest = reqbase("/zuwu-service");
Vue.prototype.$house = reqbase("/house-service");
Vue.prototype.$zulinSaasHouse = reqbase("/zulin-saas-house");

if (process.env.VUE_APP_ENV !== "production") {
  new VConsole();
}

// 全局判断是不是代运营模式
function isDaiYunYing() {
  return reqbase("")
    .get("/users/business/gray", { params: {} })
    .then(res => {
      const { hasAgentApartment } = res.data || {};
      window.hasAgentApartment = hasAgentApartment;
      return true;
    })
    .catch(() => {
      return "/users/business/gray";
    });
}

// 获取用户权限点
function getPermissions() {
  window.permissions = [];
  return reqbase("")
    .get("/perms/getFrontPermissions")
    .then(({ data = {} }) => {
      const permissions =
        (data && data.data && data.data.map(item => item.key)) || [];
      window.permissions = permissions;
      return true;
    })
    .catch(() => {
      return "/perms/getFrontPermissions";
    });
}

function loadjs(url, callback) {
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;
  if (script.onreadystatechange) {
    script.onreadystatechange = function() {
      if (script.readyState == "loaded" || script.readyState == "complete") {
        callback(); //script is loaded
      }
    };
  } else {
    script.onload = function() {
      callback(); //script is loaded;
    };
  }
  document.getElementsByTagName("head")[0].appendChild(script);
}

if (judgePrivacy()) {
  new Vue({
    router,
    store,
    el: "#app",
    render: h => h(App)
  });
} else {
  loadjs(
    "https://s1.ljcdn.com/m-base/release/v04.12/asset/bridge_91204cb40ddb0aex.js",
    () => {
      window.$ljBridge.ready((bridge, webstatus) => {
        if (process.env.VUE_APP_ENV === "dev") {
          window.saasHeaders = {
            LianjiaDeviceId: "b70ce29a3b7dfa32",
            LianjiaDeviceType: "OPPO PACM00",
            AppVersion: "1.0.0",
            WebType: "wifi",
            LianjiaAccessToken: "2.0111a9beb2842b09150001cb54051db41cac4a8285",
            channel: 11
          };
        } else {
          window.saasHeaders = {
            LianjiaDeviceId: bridge.getDeviceId(),
            LianjiaDeviceType: bridge.getDeviceInfo(),
            AppVersion: bridge.getAppVersion(),
            WebType: bridge.getNetwork(),
            LianjiaAccessToken: bridge.getAccessToken(),
            channel: 11
          };
        }
        Promise.all([isDaiYunYing(), getPermissions()]).then(values => {
          const item = values.find(item => item !== true);
          if (item) return Toast(`${item}接口请求出错`);
          // 实例化vue
          new Vue({
            router,
            store,
            el: "#app",
            render: h => h(App)
          });
        });
      });
    }
  );
}
